import React from 'react';
import { Link } from 'react-router-dom';

const CatagorieChart = ({ catagory }) => {
    const { img, name, id } = catagory;
    return (
        <div className="card w-96 bg-base-100 shadow-xl">
            <figure><img src={img} alt="books" /></figure>
            <div className="card-body">
                <h2 className="card-title" > <Link to={`/category/${id}`} className='text-black fw-bold'>{name}</Link></h2>
            </div>
        </div>
    );
};

export default CatagorieChart;